export const contentIdentifier = {
  input: {
    identifier: "Eindeutiger Identifier"
  }
};
